(function() {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function tagSectionsForFadeUp() {
    var selectors = [
      '.nm-section-head', '.nm-prog-card', '.nm-prog-card-v2',
      '.nm-finder-card', '.nm-cat-tile', '.nm-test-card',
      '.nm-pilar-card', '.nm-formacion-card', '.nm-tipo-card',
      '.nm-metodo-card', '.nm-price-box', '.nm-price-card',
      '.nm-tarifa-card', '.nm-method-narrative-content > *',
      '.nm-founder-content > *', '.nm-trust-item', '.nm-method-quote',
      '.nm-disciplina-chip', '.nm-week-day', '.nm-faq-flat-item',
      '.nm-intro-card', '.nm-stepper-step', '.nm-final-cta-inner > *',
      '.nm-bio-strip-inner', '.nm-cta-row > *'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(el) {
      if (!el.classList.contains('nm-fade-up') && !el.closest('.nm-hero')) {
        el.classList.add('nm-fade-up');
      }
    });
  }

  function setupFadeUp() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.nm-fade-up').forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          if (el.parentElement) {
            var siblings = Array.prototype.filter.call(el.parentElement.children, function(c) { return c.classList.contains('nm-fade-up'); });
            var idx = siblings.indexOf(el);
            if (idx > 0 && idx < 8) el.style.transitionDelay = (idx * 80) + 'ms';
          }
          el.classList.add('is-visible');
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.nm-fade-up').forEach(function(el) { observer.observe(el); });
  }

  function setupHeroParallax() {
    if (window.innerWidth < 769) return;
    var heros = document.querySelectorAll('.nm-hero-bg, .nm-page-hero-bg');
    if (!heros.length) return;
    var ticking = false;
    function update() {
      heros.forEach(function(bg) {
        var p = bg.parentElement;
        if (!p) return;
        var rect = p.getBoundingClientRect();
        if (rect.bottom > -100 && rect.top < window.innerHeight + 100) {
          var t = (-rect.top) * 0.15;
          var maxT = p.offsetHeight * 0.07;
          t = Math.max(-maxT, Math.min(maxT, t));
          bg.style.transform = 'translate3d(0,' + t + 'px,0)';
        }
      });
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function splitTextNodesIntoWords(parent) {
    var nodes = Array.prototype.slice.call(parent.childNodes);
    nodes.forEach(function(node) {
      if (node.nodeType === 3) {
        var text = node.textContent;
        if (!text.trim()) return;
        var fragment = document.createDocumentFragment();
        var parts = text.split(/(\s+)/);
        parts.forEach(function(part) {
          if (part.match(/\S/)) {
            var span = document.createElement('span');
            span.className = 'nm-word';
            span.textContent = part;
            fragment.appendChild(span);
          } else if (part) {
            fragment.appendChild(document.createTextNode(part));
          }
        });
        if (fragment.childNodes.length > 0) parent.replaceChild(fragment, node);
      } else if (node.nodeType === 1 && node.tagName !== 'BR' && !node.classList.contains('nm-word')) {
        splitTextNodesIntoWords(node);
      }
    });
  }

  function splitHeroWords() {
    document.querySelectorAll('.nm-h-hero').forEach(function(h1) {
      if (h1.dataset.splitDone) return;
      h1.dataset.splitDone = '1';
      splitTextNodesIntoWords(h1);
      h1.querySelectorAll('.nm-word').forEach(function(w, i) {
        w.style.animationDelay = (0.25 + i * 0.08) + 's';
      });
    });
  }

  function setupSectionHeadingWords() {
    var els = document.querySelectorAll('.nm-h-section, .nm-page-hero h1');
    if (!els.length) return;
    els.forEach(function(h) {
      if (h.dataset.splitDone) return;
      h.dataset.splitDone = '1';
      splitTextNodesIntoWords(h);
      h.querySelectorAll('.nm-word').forEach(function(w, i) {
        w.style.transitionDelay = (i * 0.06) + 's';
      });
    });
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(h) { h.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -50px 0px' });
    els.forEach(function(h) { obs.observe(h); });
  }

  function setupMaskReveal() {
    // Safety: forzar visibilidad después de 3s si observer falla
    setTimeout(function() {
      document.querySelectorAll('.nm-mask-reveal').forEach(function(el) {
        el.classList.add('is-visible');
      });
    }, 3000);
    var sels = [
      '.nm-founder-img', '.nm-method-narrative-img', '.nm-featured-prog-img',
      '.nm-prog-featured-img', '.nm-sobre-hero-img', '.nm-curso-media',
      '.nm-clases-home-img', '.nm-cat-tile-img'
    ];
    var targets = document.querySelectorAll(sels.join(','));
    if (!targets.length) return;
    targets.forEach(function(el) {
      el.classList.remove('nm-fade-up');
      el.classList.add('nm-mask-reveal');
    });
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(function(el) { obs.observe(el); });
  }

  function setupScrollProgress() {
    if (document.querySelector('.nm-scroll-progress')) return;
    var bar = document.createElement('div');
    bar.className = 'nm-scroll-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var p = docH > 0 ? Math.min(1, window.scrollY / docH) : 0;
      bar.style.transform = 'scaleX(' + p + ')';
      bar.classList.toggle('active', window.scrollY > 60);
      ticking = false;
    }
    window.addEventListener('scroll', function() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function init() {
    try {
      tagSectionsForFadeUp();
      setupFadeUp();
      setupHeroParallax();
      splitHeroWords();
      setupSectionHeadingWords();
      setupMaskReveal();
      setupScrollProgress();
    } catch (e) {
      console.warn('NM animations failed:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ================================================================
   HERO SCROLL EXIT — palabras vuelan en direcciones distintas
   ================================================================ */
(function() {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 769) return; // Desktop only

  function init() {
    var hero = document.querySelector('.nm-hero');
    if (!hero) return;

    // Esperar a que splitHeroWords haya hecho su trabajo (~250ms es seguro)
    setTimeout(function() {
      var words = hero.querySelectorAll('.nm-h-hero .nm-word');
      if (!words.length) return;

      var lead = hero.querySelector('.nm-hero-lead');
      var eyebrow = hero.querySelector('.nm-hero-eyebrow-light');
      var ctaRow = hero.querySelector('.nm-hero-cta-row');
      var fineprint = hero.querySelector('.nm-hero-fineprint');
      var heroBg = hero.querySelector('.nm-hero-bg');

      // Direcciones de salida — cada palabra vuela distinto
      var directions = [
        { x: -320, y: -180, r: -12 },
        { x: 320, y: -130, r: 10 },
        { x: -240, y: 280, r: -18 },
        { x: 300, y: 240, r: 14 },
        { x: -380, y: 60,  r: -8 },
        { x: 360, y: -280, r: 18 },
        { x: -180, y: -320, r: -6 },
        { x: 240, y: 320, r: 16 }
      ];
      words.forEach(function(w, i) {
        var d = directions[i % directions.length];
        w.dataset.exitX = d.x;
        w.dataset.exitY = d.y;
        w.dataset.exitR = d.r;
      });

      var supports = [eyebrow, lead, ctaRow, fineprint].filter(Boolean);
      var ticking = false;

      function update() {
        var rect = hero.getBoundingClientRect();
        var heroH = hero.offsetHeight || 700;
        var progress = Math.max(0, Math.min(1, -rect.top / heroH));

        // Al tope: limpiar inline styles, deja que el CSS animation inicial corra
        if (window.scrollY < 5) {
          words.forEach(function(w) { w.style.transform = ''; w.style.opacity = ''; });
          supports.forEach(function(el) { el.style.transform = ''; el.style.opacity = ''; });
          ticking = false;
          return;
        }

        // Palabras: vuelan en su dirección asignada + rotate + fade
        words.forEach(function(w) {
          var x = parseFloat(w.dataset.exitX) * progress;
          var y = parseFloat(w.dataset.exitY) * progress;
          var r = parseFloat(w.dataset.exitR) * progress;
          var op = Math.max(0, 1 - progress * 1.35);
          w.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + r + 'deg)';
          w.style.opacity = op;
        });

        // Eyebrow / lead / CTA / fineprint: fade down con stagger
        supports.forEach(function(el, i) {
          var offset = i * 0.05;
          var op = Math.max(0, 1 - Math.max(0, progress - offset) * 1.6);
          el.style.opacity = op;
          el.style.transform = 'translateY(' + (progress * 80) + 'px)';
        });

        // Background: leve zoom out cuando avanza el scroll
        if (heroBg) {
          var scale = 1 + progress * 0.08;
          // Preservamos translate del parallax existente leyendo su estilo
          var existing = heroBg.style.transform || '';
          var tMatch = existing.match(/translate3d\(0,\s*(-?\d+(?:\.\d+)?)px/);
          var ty = tMatch ? parseFloat(tMatch[1]) : 0;
          heroBg.style.transform = 'translate3d(0,' + ty + 'px,0) scale(' + scale + ')';
        }

        ticking = false;
      }

      window.addEventListener('scroll', function() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });

      update();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* ================================================================
   HERO SCROLL EXIT v2 — patch usando rect.top (no scrollY)
   ================================================================ */
(function() {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 769) return;

  setTimeout(function() {
    var hero = document.querySelector('.nm-hero');
    if (!hero) return;
    var words = hero.querySelectorAll('.nm-h-hero .nm-word');
    if (!words.length) return;

    var lead = hero.querySelector('.nm-hero-lead');
    var eyebrow = hero.querySelector('.nm-hero-eyebrow-light');
    var ctaRow = hero.querySelector('.nm-hero-cta-row');
    var fineprint = hero.querySelector('.nm-hero-fineprint');
    var heroBg = hero.querySelector('.nm-hero-bg');
    var supports = [eyebrow, lead, ctaRow, fineprint].filter(Boolean);

    // Re-asignar direcciones por si la versión vieja no las puso
    var directions = [
      { x: -320, y: -180, r: -12 },
      { x: 320, y: -130, r: 10 },
      { x: -240, y: 280, r: -18 },
      { x: 300, y: 240, r: 14 },
      { x: -380, y: 60,  r: -8 },
      { x: 360, y: -280, r: 18 },
      { x: -180, y: -320, r: -6 },
      { x: 240, y: 320, r: 16 }
    ];
    words.forEach(function(w, i) {
      var d = directions[i % directions.length];
      w.dataset.exitX = d.x;
      w.dataset.exitY = d.y;
      w.dataset.exitR = d.r;
    });

    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      var heroH = hero.offsetHeight || 700;
      var progress = Math.max(0, Math.min(1, -rect.top / heroH));

      // FIX: chequeamos progress (basado en rect.top), no scrollY que está roto en Horizon
      if (progress < 0.01) {
        words.forEach(function(w) { w.style.transform = ''; w.style.opacity = ''; });
        supports.forEach(function(el) { el.style.transform = ''; el.style.opacity = ''; });
        ticking = false;
        return;
      }

      words.forEach(function(w) {
        var x = parseFloat(w.dataset.exitX || 0) * progress;
        var y = parseFloat(w.dataset.exitY || 0) * progress;
        var r = parseFloat(w.dataset.exitR || 0) * progress;
        var op = Math.max(0, 1 - progress * 1.35);
        w.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + r + 'deg)';
        w.style.opacity = op;
      });

      supports.forEach(function(el, i) {
        var offset = i * 0.05;
        var op = Math.max(0, 1 - Math.max(0, progress - offset) * 1.6);
        el.style.opacity = op;
        el.style.transform = 'translateY(' + (progress * 80) + 'px)';
      });

      if (heroBg) {
        var scale = 1 + progress * 0.08;
        var existing = heroBg.style.transform || '';
        var tMatch = existing.match(/translate3d\(0(?:px)?,\s*(-?\d+(?:\.\d+)?)px/);
        var ty = tMatch ? parseFloat(tMatch[1]) : 0;
        heroBg.style.transform = 'translate3d(0,' + ty + 'px,0) scale(' + scale + ')';
      }

      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }, 500);
})();
/* ================================================================
   HERO SCROLL EXIT v3 — patch con retry, sin timing issues
   ================================================================ */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 769) return;

  function setup() {
    var hero = document.querySelector('.nm-hero');
    if (!hero) return;
    var words = hero.querySelectorAll('.nm-h-hero .nm-word');
    if (!words.length) {
      // Si splitHeroWords aún no corrió, reintentar
      setTimeout(setup, 200);
      return;
    }

    var dirs = [
      {x:-320,y:-180,r:-12},{x:320,y:-130,r:10},
      {x:-240,y:280,r:-18},{x:300,y:240,r:14},
      {x:-380,y:60,r:-8},{x:360,y:-280,r:18},
      {x:-180,y:-320,r:-6},{x:240,y:320,r:16}
    ];
    words.forEach(function(w,i){
      var d = dirs[i%dirs.length];
      w.dataset.exitX = d.x;
      w.dataset.exitY = d.y;
      w.dataset.exitR = d.r;
    });

    var lead = hero.querySelector('.nm-hero-lead');
    var eyebrow = hero.querySelector('.nm-hero-eyebrow-light');
    var ctaRow = hero.querySelector('.nm-hero-cta-row');
    var fineprint = hero.querySelector('.nm-hero-fineprint');
    var heroBg = hero.querySelector('.nm-hero-bg');
    var supports = [eyebrow, lead, ctaRow, fineprint].filter(Boolean);

    var ticking = false;
    function update() {
      var rect = hero.getBoundingClientRect();
      var progress = Math.max(0, Math.min(1, -rect.top / (hero.offsetHeight || 700)));

      words.forEach(function(w){
        var x = parseFloat(w.dataset.exitX||0) * progress;
        var y = parseFloat(w.dataset.exitY||0) * progress;
        var r = parseFloat(w.dataset.exitR||0) * progress;
        w.style.transform = 'translate('+x+'px,'+y+'px) rotate('+r+'deg)';
        w.style.opacity = progress < 0.01 ? '' : Math.max(0, 1 - progress * 1.35);
        if (progress < 0.01) w.style.transform = '';
      });

      supports.forEach(function(el, i){
        var op = Math.max(0, 1 - Math.max(0, progress - i*0.05) * 1.6);
        el.style.opacity = progress < 0.01 ? '' : op;
        el.style.transform = progress < 0.01 ? '' : ('translateY('+(progress*80)+'px)');
      });

      if (heroBg && progress > 0.01) {
        var scale = 1 + progress * 0.08;
        var existing = heroBg.style.transform || '';
        var tMatch = existing.match(/translate3d\(0(?:px)?,\s*(-?\d+(?:\.\d+)?)px/);
        var ty = tMatch ? parseFloat(tMatch[1]) : 0;
        heroBg.style.transform = 'translate3d(0,' + ty + 'px,0) scale(' + scale + ')';
      }

      ticking = false;
    }

    window.addEventListener('scroll', function(){
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(setup, 400); });
  } else {
    setTimeout(setup, 400);
  }
})();
/* Cerrar buscador / mobile panel al tap fuera */
document.addEventListener('click', function(e) {
  var searchOverlay = document.querySelector('.nm-search-overlay.show');
  if (searchOverlay && e.target === searchOverlay) {
    if (window.NM && window.NM.closeSearch) NM.closeSearch();
    else searchOverlay.classList.remove('show');
  }
  var mobileOverlay = document.querySelector('.nm-mobile-panel-overlay.open');
  if (mobileOverlay && e.target === mobileOverlay) {
    if (window.NM && window.NM.toggleMobileMenu) NM.toggleMobileMenu();
    else {
      mobileOverlay.classList.remove('open');
      var panel = document.querySelector('.nm-mobile-panel');
      if (panel) panel.classList.remove('open');
    }
  }
});

/* ESC también cierra */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    var search = document.querySelector('.nm-search-overlay.show');
    if (search) {
      if (window.NM && window.NM.closeSearch) NM.closeSearch();
      else search.classList.remove('show');
    }
  }
});
/* Bloquear apertura de zoom-dialog en producto */
document.addEventListener('click', function(e) {
  var zoomTrigger = e.target.closest('.product-media-container--zoomable, [data-zoom-trigger]');
  if (zoomTrigger) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}, true);
/* === Mobile: sync dots con scroll del carousel programas === */
(function(){
  var isMobile = function(){ return window.matchMedia('(max-width: 600px)').matches; };
  document.querySelectorAll('.nm-prog-carousel-track').forEach(function(track){
    var section = track.closest('.shopify-section, section') || document;
    var dots = section.querySelectorAll('.nm-prog-carousel-dots button');
    var cards = track.querySelectorAll('.nm-prog-card-v2');
    if (!dots.length || !cards.length) return;

    var ticking = false;
    function sync(){
      if (!isMobile()) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var scrollLeft = track.scrollLeft;
        var cardWidth = cards[0].offsetWidth + 16;
        var idx = Math.round(scrollLeft / cardWidth);
        idx = Math.max(0, Math.min(dots.length - 1, idx));
        dots.forEach(function(d, i){ d.classList.toggle('active', i === idx); });
        ticking = false;
      });
    }
    track.addEventListener('scroll', sync, {passive: true});

    // Click dot en mobile: scroll al card correspondiente (en vez de que el JS del theme haga transform)
    dots.forEach(function(d, i){
      d.addEventListener('click', function(e){
        if (!isMobile()) return;
        e.stopPropagation();
        e.preventDefault();
        var cardWidth = cards[0].offsetWidth + 16;
        track.scrollTo({left: i * cardWidth, behavior: 'smooth'});
      }, true);
    });
  });
})();
/* === Auto-refresh del contador del carrito === */
(function(){
  var el = document.querySelector('[data-cart-count]');
  if (!el) return;

  function refresh(){
    fetch('/cart.js', {headers: {'Accept': 'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){
        el.textContent = c.item_count;
        el.classList.toggle('is-empty', c.item_count === 0);
      })
      .catch(function(){});
  }

  // Interceptar fetch de /cart/add
  var origFetch = window.fetch;
  window.fetch = function(url, opts){
    var p = origFetch.apply(this, arguments);
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function(){ setTimeout(refresh, 100); });
    }
    return p;
  };

  // Eventos que dispara Horizon al modificar el carrito
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function(ev){
    document.addEventListener(ev, refresh);
  });
})();

/* === Colapsar toda la descripción del programa en 1 acordeón === */
(function(){
  function accordionize(){
    var containers = document.querySelectorAll(
      '.product-details .rte, .product-details__description-rte, ' +
      '.product-details__description, .product-description, ' +
      '.product-info .rte, [data-block-type="details"] .rte, ' +
      '.product__description'
    );

    containers.forEach(function(container){
      if (container.classList.contains('nm-desc-done')) return;
      var originalHTML = container.innerHTML.trim();
      if (!originalHTML) return;
      container.classList.add('nm-desc-done');

      container.innerHTML =
        '<details class="nm-desc-master">' +
          '<summary>' +
            '<span class="nm-acc-title">Detalles del programa</span>' +
            '<span class="nm-acc-chev" aria-hidden="true">+</span>' +
          '</summary>' +
          '<div class="nm-desc-master-content">' + originalHTML + '</div>' +
        '</details>';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', accordionize);
  } else {
    accordionize();
  }
})();

/* === WhatsApp button: evitar solapamiento con sticky footer === */
(function(){
  var wa = document.querySelector('.nm-wa-float');
  if (!wa) return;

  function check(){
var bars = document.querySelectorAll(
  '.nm-sticky-cta, ' +
  '.sticky-add-to-cart__bar, ' +
  '[class*="sticky-add-to-cart"]:not(sticky-add-to-cart), ' +
  '[class*="sticky-atc__bar"], ' +
  '[class*="sticky-buy__bar"]'
);
    var showing = false;
    bars.forEach(function(bar){
      var r = bar.getBoundingClientRect();
      var cs = getComputedStyle(bar);
      // Está visible SI: tiene tamaño real, opacidad > 0, no está hidden/display none,
      // Y su rect está dentro del viewport (no transformado fuera)
      if (r.height > 20 && r.width > 100 &&
          parseFloat(cs.opacity) > 0.1 &&
          cs.visibility !== 'hidden' &&
          cs.display !== 'none' &&
          r.top < window.innerHeight - 20 &&
          r.bottom > 0) {
        showing = true;
      }
    });
    wa.classList.toggle('nm-wa-shifted', showing);
  }

  window.addEventListener('scroll', check, {passive: true});
  window.addEventListener('resize', check, {passive: true});

  // Observar cambios de clase/style en las barras (Horizon toggle via CSS)
  var mo = new MutationObserver(check);
  document.querySelectorAll('.nm-sticky-cta, .sticky-add-to-cart__bar, sticky-add-to-cart, [class*="sticky-add-to-cart"]').forEach(function(bar){
    mo.observe(bar, {attributes: true, attributeFilter: ['class', 'style']});
  });

  check();
  setTimeout(check, 500);
  setTimeout(check, 1500);
})();
document.querySelectorAll('[data-nm-rating]').forEach(function(picker){
  var stars = picker.querySelectorAll('.nm-review-form-star');
  var input = picker.querySelector('input[type="hidden"]');
  function set(v){
    input.value = v;
    stars.forEach(function(s){
      s.classList.toggle('is-active', parseInt(s.dataset.value) <= v);
    });
  }
  set(5); // default 5 estrellas
  stars.forEach(function(s){
    s.addEventListener('click', function(){ set(parseInt(s.dataset.value)); });
    s.addEventListener('mouseenter', function(){
      var v = parseInt(s.dataset.value);
      stars.forEach(function(x){
        x.classList.toggle('is-hover', parseInt(x.dataset.value) <= v);
      });
    });
    s.addEventListener('mouseleave', function(){
      stars.forEach(function(x){ x.classList.remove('is-hover'); });
    });
  });
});
/* === Home testimonios: carrusel + leer más === */
(function(){
  var section = document.querySelector('.nm-testimonials');
  if (!section) return;
  var grid = section.querySelector('.nm-test-grid');
  if (!grid) return;

  // Agregar chevrons de navegación
  if (!section.querySelector('.nm-test-carousel-controls')) {
    var controls = document.createElement('div');
    controls.className = 'nm-test-carousel-controls';
    controls.innerHTML =
      '<button type="button" class="nm-test-carousel-btn" data-nm-test-prev aria-label="Anterior">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button type="button" class="nm-test-carousel-btn" data-nm-test-next aria-label="Siguiente">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>';
    grid.parentElement.insertBefore(controls, grid.nextSibling);
  }

  var prev = section.querySelector('[data-nm-test-prev]');
  var next = section.querySelector('[data-nm-test-next]');

  function updateBtns() {
    if (!prev || !next) return;
    prev.disabled = grid.scrollLeft <= 5;
    next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 5;
  }

  if (prev) prev.addEventListener('click', function(){
    grid.scrollBy({left: -grid.clientWidth, behavior: 'smooth'});
  });
  if (next) next.addEventListener('click', function(){
    grid.scrollBy({left: grid.clientWidth, behavior: 'smooth'});
  });
  grid.addEventListener('scroll', updateBtns, {passive: true});
  window.addEventListener('resize', updateBtns, {passive: true});
  setTimeout(updateBtns, 100);

  // "Leer más" por card

section.querySelectorAll('.nm-test-card').forEach(function(card){
  var quote = card.querySelector('.nm-test-quote');
  if (!quote) return;
  // guard: no duplicar botón si ya existe
  if (card.querySelector('.nm-test-readmore')) return;
  if (card.dataset.nmReadmoreProcessed) return;
  card.dataset.nmReadmoreProcessed = '1';

  setTimeout(function(){
    if (card.querySelector('.nm-test-readmore')) return;
    if (quote.scrollHeight > quote.clientHeight + 2) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nm-test-readmore';
      btn.textContent = 'Leer más';
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        var isExpanded = card.classList.toggle('is-expanded');
        btn.textContent = isExpanded ? 'Leer menos' : 'Leer más';
      });
      quote.parentElement.insertBefore(btn, quote.nextSibling);
    }
  }, 150);
});
})();
document.querySelectorAll('.nm-test-readmore').forEach(function(b, i, all){
  var card = b.closest('.nm-test-card');
  var siblings = card.querySelectorAll('.nm-test-readmore');
  if (siblings.length > 1) {
    for (var j = 1; j < siblings.length; j++) siblings[j].remove();
  }
});

/* === Scroll-down indicator en heros === */
(function(){
  function init(){
    var nav = document.querySelector('.nm-nav');
    document.querySelectorAll('.nm-hero, .nm-page-hero').forEach(function(hero){
      if (hero.querySelector('.nm-scroll-ind')) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nm-scroll-ind';
      btn.setAttribute('aria-label', 'Bajar al contenido');
      btn.innerHTML = '<span class="nm-scroll-ind-mouse"></span><span class="nm-scroll-ind-label">Scroll</span>';
      hero.appendChild(btn);

      btn.addEventListener('click', function(){
        var sec = hero.closest('.shopify-section') || hero;
        var next = sec.nextElementSibling;
        while (next && next.offsetHeight === 0) next = next.nextElementSibling;
        if (!next) return;
        next.style.scrollMarginTop = (nav ? nav.offsetHeight : 0) + 'px';
        next.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Se oculta apenas empiezas a bajar
      function upd(){ btn.classList.toggle('is-hidden', hero.getBoundingClientRect().top < -60); }
      document.addEventListener('scroll', upd, { passive: true, capture: true });
      upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* === Intro del programa arriba de los módulos de LDT === */
(function(){
  if (!/\/products\//.test(location.pathname)) return;

  // Lee la descripción del producto y toma los párrafos de introducción
  function getIntro(){
    var url = location.pathname.replace(/\/$/, '') + '.js';
    return fetch(url).then(function(r){ return r.json(); }).then(function(p){
      var tmp = document.createElement('div');
      tmp.innerHTML = p.description || '';
      var parts = [];
      for (var i = 0; i < tmp.children.length && parts.length < 2; i++) {
        var el = tmp.children[i];
        var t = el.textContent.trim();
        if (el.tagName !== 'P' || !t) { if (parts.length) break; else continue; }
        if (/:$/.test(t)) break;          // se detiene en "A lo largo del programa trabajaremos:"
        parts.push(t);
      }
      return parts;
    });
  }

  function inject(parts){
    var w = document.querySelector('.ldt-cr-preview-course-content');
    if (!w) return false;
    if (w.querySelector('.nm-ldt-intro')) return true;
    var acc = w.querySelector('.ldt-cr-acc');
    if (!acc) return false;

    var box = document.createElement('div');
    box.className = 'nm-ldt-intro';
    box.innerHTML = parts.map(function(t, i){
      var safe = t.replace(/&/g, '&amp;').replace(/</g, '&lt;');
      return '<p' + (i === 0 ? ' class="nm-ldt-intro-lead"' : '') + '>' + safe + '</p>';
    }).join('');
    acc.parentNode.insertBefore(box, acc);

    // Evita repetir esos mismos párrafos dentro de "Detalles del programa"
    document.querySelectorAll('.nm-desc-master-content > p').forEach(function(p){
      if (parts.indexOf(p.textContent.trim()) !== -1) p.style.display = 'none';
    });
    return true;
  }

  getIntro().then(function(parts){
    if (!parts.length) return;
    if (inject(parts)) return;
    // El widget de LDT carga después: esperamos a que aparezca
    var mo = new MutationObserver(function(){ if (inject(parts)) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function(){ mo.disconnect(); }, 15000);
  }).catch(function(){});
})();